(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["feeds/hide-comment-preview"] = factory();
	else
		root["feeds/hide-comment-preview"] = factory();
})(globalThis, () => {
return 